/* eslint-disable */
// @ts-nocheck
// import instantsearch from 'instantsearch.js/dist/instantsearch.production.min';
import algoliasearch from "algoliasearch";
import { autocomplete } from "@algolia/autocomplete-js";
import { createQuerySuggestionsPlugin } from "@algolia/autocomplete-plugin-query-suggestions";
import instantsearch from "instantsearch.js";
import { index, configure, hits, searchBox } from "instantsearch.js/es/widgets";
import {
  connectAutocomplete,
  connectHits,
} from "instantsearch.js/es/connectors";
import { __ } from "@wordpress/i18n";

const header = document.querySelector(".header");
const algoliaData = header.dataset.algolia ?? "";
const algoliaAppID = header.dataset.algoliaAppId ?? "";
const algoliaApiKey = header.dataset.algoliaApiKey ?? "";

const headerMobile = document.querySelector(".header--mobile");
const inputMobile = document.querySelector("#search-box-mobile");
const submitbutton = document.querySelector("#search-submit");
const form = document.querySelector("#search-form");

const input = document.querySelector("#search-box");

const algoliaSetup = {
  applicationID: algoliaAppID,
  searchApiKey: algoliaApiKey,
};

const algoliaIndexes = {
  bsr: {
    indexName: "bsr_wpb_posts_resources",
    indexQueryName: "bsr_wpb_posts_resources_query_suggestions",
  },
  "bsr-en": {
    indexName: "bsr_en_wpb_posts_resources",
    indexQueryName: "bsr_en_wpb_posts_resources_query_suggestions",
  },
  cmnty: {
    indexName: "cmnty_wpb_posts_resources",
    indexQueryName: "cmnty_wpb_posts_resources_query_suggestions",
  },
  "cmnty-en": {
    indexName: "cmnty_en_wpb_posts_resources",
    indexQueryName: "cmnty_en_wpb_posts_resources_query_suggestions",
  },
  mr: {
    indexName: "wpb_posts_resources",
    indexQueryName: "wpb_posts_resources_query_suggestions",
  },
  "mr-en": {
    indexName: "en_wpb_posts_resources",
    indexQueryName: "en_wpb_posts_resources_query_suggestions",
  },
  underlined: {
    indexName: "underlined_wpb_posts_resources",
    indexQueryName: "underlined_wpb_posts_resources_query_suggestions",
  },
  "underlined-en": {
    indexName: "underlined_en_wpb_posts_resources",
    indexQueryName: "underlined_en_wpb_posts_resources_query_suggestions",
  },
};

const algoliaInit = () => {
  if (!algoliaData) {
    return;
  }

  let isMobile = window.matchMedia("(max-width: 992px)").matches;

  const keywords = isMobile
    ? document.querySelector("#hits-box-mobile-keywords")
    : document.querySelector("#hits-box-keywords");
  const cases = isMobile
    ? document.querySelector("#hits-box-mobile-cases")
    : document.querySelector("#hits-box-cases");
  const resources = isMobile
    ? document.querySelector("#hits-box-mobile-downloads")
    : document.querySelector("#hits-box-downloads");
  const downloads = isMobile
    ? document.querySelector("#hits-box-mobile-resources")
    : document.querySelector("#hits-box-resources");

  input.addEventListener("keyup", (e) => {
    search.helper.setQuery(e.target.value).search();
  });

  inputMobile.addEventListener("keyup", (e) => {
    search.helper.setQuery(e.target.value).search();
  });

  const searchClient = algoliasearch(
    algoliaSetup.applicationID,
    algoliaSetup.searchApiKey
  );

  const search = instantsearch({
    indexName: algoliaIndexes[algoliaData].indexName,
    searchClient,
  });

  const structuredResults = connectHits(({ hits, widgetParams }) => {
    const { container } = widgetParams;
    let count = 0;

    container.innerHTML = hits
      .map((hit: any) => {
        if (count <= 2) {
          count += 1;
          return `
                <a href="${hit.permalink}">
                  ${hit.post_title + " - " + hit.taxonomies.category[0]}
                </a>
                `;
        }
      })
      .join("");
  });

  const structuredKeywords = connectHits(({ hits, widgetParams }) => {
    const { container } = widgetParams;
    let count = 0;
    let resultsNumber = isMobile ? 2 : 6;

    container.innerHTML = hits
      .map((hit: any) => {
        if (count <= resultsNumber) {
          count += 1;
          let query = window.location.origin + "/?s=" + hit.query;
          return `<a href="${query}">
                  ${hit.query}
                </a> `;
        }
      })
      .join("");
  });

  search.addWidgets([
    // Add your widgets here
    index({ indexName: algoliaIndexes[algoliaData].indexName }).addWidgets([
      configure({
        facetFilters: ["taxonomies.category:" + "Nieuws"],
      }),
      structuredResults({
        container: downloads,
      }),
    ]),
    index({ indexName: algoliaIndexes[algoliaData].indexName }).addWidgets([
      configure({
        facetFilters: ["taxonomies.category:" + "Downloads"],
      }),
      structuredResults({
        container: resources,
      }),
    ]),
    index({ indexName: algoliaIndexes[algoliaData].indexName }).addWidgets([
      configure({
        facetFilters: ["taxonomies.category:" + "Cases"],
      }),
      structuredResults({
        container: cases,
      }),
    ]),
    index({ indexName: algoliaIndexes[algoliaData].indexQueryName }).addWidgets(
      [
        structuredKeywords({
          container: keywords,
        }),
      ]
    ),
  ]);

  search.start();

  submitbutton.addEventListener("click", (e) => {
    e.preventDefault();
    form.submit();
  });

  submitbutton.addEventListener("touchdown", (e) => {
    e.preventDefault();
    form.submit();
  });
};
export default algoliaInit;
